import { TranslateService } from '@ngx-translate/core';
import { FunnelService } from 'src/app/pages/new-service/services/funnel.service';
import { myToppingDictionary, ToppingIds } from './../../../../../new-service/constants/ToppingDictionary';
import { Component, computed, EventEmitter, Input, Output } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { GetValuesService } from 'src/app/core/services/get-values.service';
import { EditServiceService, FORM_KEYS } from '../../edit-service.service';
import { MappedProduct, MappedTopping } from 'src/app/pages/new-service/interfaces/Topping';
import { Product } from 'src/app/models/category.model';
import { scrollToElement } from 'src/app/shared/utilities/utils';
import { ProductKey } from 'src/app/core/enums/ProductKey';

enum Step {
  Step1 = 1,
  Step2 = 2
}

// export enum ProductKeys {
//   REFUELING_CAR_TOPPING = "refueling-car-topping", // PRINCIPAL PRODUCT
//   REFUELING_TOPPING = "refueling-topping" // TOPPING
// }



@Component({
  selector: 'app-service-info-step',
  templateUrl: './service-info-step.component.html',
  styleUrls: ['./service-info-step.component.scss']
})
export class ServiceInfoStepComponent {

  CurrentStep: Step = Step.Step1;
  EditingTopping: any
  Step = Step
  FORM_KEYS = FORM_KEYS;

  myToppingDictionary = myToppingDictionary;

  ToppingIds = ToppingIds;
  ProductKeys = ProductKey;

  @Input() ServiceForm: FormGroup | null | undefined = undefined;
  @Input() ToppingList: MappedTopping[] = [];
  @Output() nextStepEmitter = new EventEmitter();
  @Output() backStepEmitter = new EventEmitter();


  ProductsCopy!: FormArray<FormGroup>;

  PossibleWashProductsIds: ToppingIds[] = [ToppingIds.INTERIOR_CAR_WASH_TOPPING, ToppingIds.EXTERIOR_CAR_WASH_TOPPING, ToppingIds.COMPLETE_CAR_WASH_TOPPING, ToppingIds.MOTORBIKE_WASH_TOPPING, ToppingIds.TUNNEL_EXTERIOR_CAR_WASH_TOPPING]
  PossibleRefuelProductsIds: ToppingIds[] = [ToppingIds.REFUELING_TOPPING]

  ModifyLinkList: (ToppingIds | undefined)[] = [ToppingIds.REFUELING, ToppingIds.WASH]
  EditableToppings: (ToppingIds | undefined)[] = [ToppingIds.REFUELING, ToppingIds.WASH, ToppingIds.CHECKSTATUSVEHICLE]

  StepParentId = "step-parent-id"
  StepContainerId = "step-container-id"

  constructor(private getValuesService: GetValuesService, private EditServiceService: EditServiceService, private FunnelService: FunnelService, private TranslateService: TranslateService) { }

  ngOnInit() {
    this.createProductsCopy();
    this.ToppingList = this.filterSortToppings(this.ToppingList);
    this.recalculateProductDetails();

    this.Products.valueChanges.subscribe(() => {
      this.recalculateProductDetails();
    });

  }




  isToppingSelected(topping: MappedTopping): boolean {
    const selectedProductKeys = this.Products.value.map(
      (product: MappedTopping) => product.ProductKey
    );

    return topping?.products?.some((product: MappedProduct) =>
      selectedProductKeys.includes(product.productKey)
    ) || topping?.products?.some((product: MappedProduct) =>
      product.relatedProducts?.some((related: MappedProduct) =>
        selectedProductKeys.includes(related.productKey)
      )
    );
  }

  filterSortToppings(toppings: MappedTopping[]): MappedTopping[] {
    return toppings
      .filter((x: MappedTopping) => {
        return this.EditableToppings.includes(x.id) || this.isProductChecked(x.ProductKey as string);
      })
      .sort((a, b) => {
        const aIsEditable = this.EditableToppings.includes(a.id) ? 0 : 1;
        const bIsEditable = this.EditableToppings.includes(b.id) ? 0 : 1;
        return aIsEditable - bIsEditable;
      });
  }



  createProductsCopy(): void {
    this.ProductsCopy = this.copyFormArray(this.Products);
  }

  copyFormArray(sourceArray: FormArray): FormArray<FormGroup> {
    const copiedControls = sourceArray.controls.map(ctrl => this.copyFormGroup(ctrl as FormGroup));
    return new FormArray(copiedControls);
  }

  copyFormGroup(sourceGroup: FormGroup): FormGroup {
    const copiedControls: { [key: string]: FormControl } = {};
    Object.keys(sourceGroup.controls).forEach(key => {
      const originalControl = sourceGroup.get(key);
      copiedControls[key] = new FormControl(originalControl?.value);
    });
    return new FormGroup(copiedControls);
  }

  syncCopyToOriginal(): void {
    this.Products.clear();
    this.ProductsCopy.controls.forEach(ctrl => {
      this.Products.push(this.copyFormGroup(ctrl));
    });
  }


  onActiveProductChange(event: boolean, topping: MappedTopping): void {
    switch (topping.id) {
      case ToppingIds.WASH:
        if (event) {

          // this.MainEditingTopping = topping;
          // this.CurrentStep = Step.Step2;
          this.modifyTopping(topping)
        } else {
          this.removeProductsByKeys(this.Products, this.PossibleWashProductsIds)
        }
        break;

      case ToppingIds.REFUELING:
        if (event) {
          // this.MainEditingTopping = topping;
          // this.CurrentStep = Step.Step2;
          this.modifyTopping(topping)

        } else {
          this.removeProductFromFormArray(this.Products, topping);
        }
        break;

      default:
        if (event) {
          this.addProductToFormArray(this.Products, topping)
        } else {
          this.removeProductFromFormArray(this.Products, topping);
        }
        break;
    }

    this.createProductsCopy();
  }

  addProductToFormArray(productArray: FormArray, topping: MappedTopping): void {
    const product: MappedProduct | undefined =
      topping.products?.length === 1 ? topping.products[0] : undefined;

    const productForm = new FormGroup({
      ProductId: new FormControl(product?.id),
      ProductType: new FormControl(product?.verticalType),
      ProductKey: new FormControl(product?.productKey),
      // Amount: new FormControl(product?.Price)
      // HasTaxes: new FormControl(product?.tax)
    });

    this.Products.push(productForm);

    if (topping.id == ToppingIds.REFUELING) {
      this.modifyTopping(topping)
    }
  }

  removeProductFromFormArray(productArray: FormArray, topping: MappedTopping): void {
    if (!topping.products?.length) return;

    const productIdsToRemove = topping.products.map(p => p.id);

    const remainingControls = productArray.controls.filter(control => {
      const currentId = control.get('ProductId')?.value;
      return !productIdsToRemove.includes(currentId);
    });

    while (productArray.length !== 0) {
      productArray.removeAt(0);
    }

    remainingControls.forEach(control => productArray.push(control));
  }

  removeProductsByKeys(productArray: FormArray, productKeysToRemove: ToppingIds[]): void {
    if (!productKeysToRemove?.length) return;
    const remainingControls = productArray.controls.filter(control => {
      const currentKey = control.get('ProductKey')?.value;
      return !productKeysToRemove.includes(currentKey);
    });

    productArray.clear();

    remainingControls.forEach(control => productArray.push(control));
  }


  get Products(): FormArray {
    return this.ServiceForm?.get([FORM_KEYS.ProductData, FORM_KEYS.Products]) as FormArray;
  }

  get getProductsCopy(): FormArray {
    return this.ProductsCopy as FormArray;
  }

  productKeys = computed(() => {
    return new Set(this.Products.controls.map(c => c.get('ProductKey')?.value));
  });

  isProductChecked = (key: string | ToppingIds) => {
    return this.productKeys().has(key);
  };


  getServiceType(id?: number): string {
    if (!id) return 'Desconocido';
    return this.getValuesService.getServiceTypeString(id);
  }


  backStep(): void {
    if (this.CurrentStep == Step.Step1) {
      this.backStepEmitter.emit()
    }

    if (this.CurrentStep == Step.Step2) {
      this.CurrentStep = Step.Step1;
      this.createProductsCopy();
    }
  }

  nextStep(): void {

    if (this.CurrentStep == Step.Step1) {
      this.nextStepEmitter.emit()
    }

    if (this.CurrentStep == Step.Step2) {
      // this.onProductDataEmitter(this.EditingTopping);

      this.syncCopyToOriginal();
      this.CurrentStep = Step.Step1
    }

  }

  MainEditingTopping: any | undefined;

  modifyTopping(Topping: MappedTopping): void {
    this.CurrentStep = Step.Step2;
    this.MainEditingTopping = Topping;
    setTimeout(() => {
      scrollToElement(this.StepParentId, this.StepContainerId)
    }, 100)
  }

  getProductTopping(toppingId: string): void {
    return this.Products.value.find((x: any) => x.ProductKey === toppingId);
  }


  // Para mostrar los detalles en las cards de toppings sin comprometer la performance

  productDetailsMap: Record<string, string> = {};

  recalculateProductDetails(): void {
    this.productDetailsMap = {};

    this.ToppingList?.forEach((topping: MappedTopping) => {
      const productKey = topping.id;

      if (productKey === ToppingIds.WASH) {
        const product = this.Products.value.find((x: MappedTopping) =>
          this.PossibleWashProductsIds.includes(x.ProductKey as ToppingIds)
        );
        this.productDetailsMap[productKey] = product
          ? this.TranslateService.instant(product.ProductKey)
          : "";
      }

      if (productKey === ToppingIds.REFUELING) {
        const product = this.Products.value.find((x: MappedTopping) =>
          x.ProductKey === this.PossibleRefuelProductsIds[0]
        );
        this.productDetailsMap[productKey] = product
          ? `${this.TranslateService.instant('EDIT_SERVICES.SERVICE_INFO.3')} ${product.Amount}€`
          : "";
      }
    });
  }





}
